var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMuteSpeakerWave = function SvgIconMuteSpeakerWave(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 28a1 1 0 0 1-.71-.3L10.67 22H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l5.62-5.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v22a1 1 0 0 1-1 1M5 20h6.08a1 1 0 0 1 .71.3L16 24.57V7.43l-4.21 4.27a1 1 0 0 1-.71.3H5zM30 12.41 28.59 11 25 14.59 21.41 11 20 12.41 23.59 16 20 19.59 21.41 21 25 17.41 28.59 21 30 19.59 26.41 16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.16 8.08-1.53 1.29a10 10 0 0 1-.29 13.23l1.47 1.4a12 12 0 0 0 .35-15.88z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMuteSpeakerWave);
export { ForwardRef as ReactComponent };